const GET_DIRECTORS = "GET_DIRECTORS";
const GET_DIRECTORS_WITH_ID = "GET_DIRECTORS_WITH_ID";
const SEARCH_DIRECTOR = "SEARCH_DIRECTOR";
const ADD_DIRECTOR = "ADD_DIRECTOR";
const DELETE_DIRECTOR = "DELETE_DIRECTOR";
const UPDATE_DIRECTOR = "UPDATE_DIRECTOR";
const UPDATE_DIRECTOR_IN_DATABASE = "UPDATE_DIRECTOR_IN_DATABASE";

export {
  GET_DIRECTORS,
  GET_DIRECTORS_WITH_ID,
  SEARCH_DIRECTOR,
  ADD_DIRECTOR,
  DELETE_DIRECTOR,
  UPDATE_DIRECTOR,
  UPDATE_DIRECTOR_IN_DATABASE,
};
